// extracted by mini-css-extract-plugin
module.exports = {"h1":"_video__h1__QUQch","h2":"_video__h2__o8Q3I","h3":"_video__h3__NkrGp","dangerousHTML":"_video__dangerousHTML__533uo"};